import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "green-status",
  "use": "green-status-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"green-status\">\n    <circle cx=\"9.979\" cy=\"9.979\" r=\"4\" fill=\"#3CF927\" fill-rule=\"evenodd\" transform=\"translate(.74 .5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol